import { ObjectField } from "../models/ObjectField";

export class ObjectFieldLabelFormat {

    static build(objectField: ObjectField): string | null {

        if (objectField === null) {
            return null;
        }

        if (objectField.ObjectFieldLabel && objectField.ObjectFieldLabel.Label){
            return objectField.ObjectFieldLabel.Label
        }else{
            return objectField.Name
        }
    }
}